import { IStore } from 'store/configureStore';

export const selectHeaderTitle = (state: IStore) => state.appConfig.headerTitle;
export const selectIsSidebarOpen = (state: IStore) => state.appConfig.isSidebarOpened;
export const selectToastState = (state: IStore) => state.appConfig.toastState;
export const selectOptimizelyReady = (state: IStore) => state.appConfig.optimizelyReady;
